import React, { Component, useRef } from 'react'
import { Animated, Dimensions, Platform, Text, ViewPropTypes, View, Pressable, TouchableWithoutFeedback, Image, ScrollView } from 'react-native'
import { TextPropTypes } from 'deprecated-react-native-prop-types';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { Card, ErrorScreen, Icon, Shimmer, VFText } from '@vfgroup-oneplatform/foundation/Components';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { COMPONENT_NAMES } from '../../../Utils';
import handleIsLoading from '../../Utils';
import ConnectedApps from '../components/ConnectedApps/ConnectedApps';
import DiscoverCard from '../components/DiscoverCard/DiscoverCard';
import GroupCard from '../components/GroupCard/GroupCard';
import LoadingJson from '../Config/LoadingComponentJson.json';
import {
  dashboardLoadingConfig as _dashboardLoadingConfig,
  discoverCardLoadingConfig as _discoverCardLoadingConfig,
  lastUpdatedLoadingConfig as _lastUpdatedLoadingConfig,
  shimmerPlaceholderConfig as _shimmerPlaceholderConfig,
} from '../Config/LoadingConfig';
import Dashboard from '../Dashboard/Dashboard';
import DashboardDiscover from '../DashboardDiscover/DashboardDiscover';

import styles from './DashboardContainer.styles';

import ReactPlayer from 'react-player/lazy'
import { Images } from '../../../Themes'
import colors from '../../../../../../App/Themes/Colors'
import { language } from '../../../../../../App/Containers/Settings/Settings.Reducers'
import ReduxCache from '../../../../../../App/Utils/ReduxCache'
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';
import { get as _get } from 'lodash'
import { isAdminView, isBusinessChooser } from '../../../../../../App/Utils';

class DashboardContainer extends Component {
  constructor(props) {
    super(props);
    this.cardsRefs = [];
    this.state = {
      play: false,
      initialized: false,
      playing: false,
      heightOfPlayer: 0
    }
  }

  getMainCardItem = (cardData, componentList, loadingConfig, onPressCard, hasShadow, i) => {
    const component = _.get(componentList, cardData?.name, () => null);
    const { extraInfo = {}, error, ...otherInfo } = cardData || {};

    const accessibilityLabelsObj = {
      MainCardComponent: FrameworkTestKeys.DBmainCard,
      SecondaryCardComponent: FrameworkTestKeys.DBsecCard1,
      ThirdCardComponent: FrameworkTestKeys.DBsecCard2,
      FourthCardComponent: FrameworkTestKeys.DBsecCard3,
    };
    const accessibilityLabel = accessibilityLabelsObj[Card.name];

    const isVerticalLayout =
      cardData?.name === COMPONENT_NAMES.MAIN || cardData?.name === COMPONENT_NAMES.SECONDARY;
    const isHorizontalLayout =
      cardData?.name === COMPONENT_NAMES.THIRD || cardData?.name === COMPONENT_NAMES.FORTH;

    return {
      component,
      extraInfo,
      error: error,
      loadingConfig,
      isVerticalLayout,
      isHorizontalLayout,
      onPressCard,
      hasShadow,
      accessibilityLabel,
      ...otherInfo,
    };
  };

  getMainCards = () => {
    const { data, componentList, hasShadow, onPressCard, dashboardLoadingConfig } = this.props;
    const {
      mainCardsLoadingConfig = _dashboardLoadingConfig.mainCardsLoadingConfig,
      secCardsLoadingConfig = _dashboardLoadingConfig.secCardsLoadingConfig,
      adCardsLoadingConfig = _dashboardLoadingConfig.adCardsLoadingConfig,
    } = dashboardLoadingConfig;

    const cards = data[0]?.dashboardItems;
    let i = 0;


    return {
      Card1: this.getMainCardItem(
        cards[0],
        componentList,
        mainCardsLoadingConfig,
        onPressCard,
        hasShadow,
      ),
      Card2: this.getMainCardItem(
        cards[1],
        componentList,
        secCardsLoadingConfig,
        cards[1]?.guest?.onPress,
        hasShadow,
        i
      ),
      Card3: this.getMainCardItem(
        cards[2],
        componentList,
        adCardsLoadingConfig,
        cards[3]?.extraInfo?.onPress,
        hasShadow,
      ),
      Card4: this.getMainCardItem(
        cards[3],
        componentList,
        adCardsLoadingConfig,
        cards[3]?.extraInfo?.onPress,
        hasShadow,
      ),
    };
  };

  //Function's for web video player
  handlePlay = () => {
    this.setState({ playing: true })
  }
  handlePause = () => {
    this.setState({ playing: false })
  }
  handlePlayPause = () => {
    this.setState((prev) => {
      return {
        ...prev,
        playing: !prev.playing
      }
    })
  }


  getDashboardDiscover = items => {
    const { discoveryItems = null } = items
    const { isLoadingDiscover, theme, totalUsers } = this.props
    const { discoverFullErrorProps } = this.props;
    if (discoverFullErrorProps) {
      return this.renderDiscoverFullError()
    }
    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      const [offerAndRewards] = discoveryItems.filter((item) => item.key === 'itemsOffer&rewards')
      const [discover] = discoveryItems.filter((item) => item.componentId === 'DiscoverCarousel')
      const [SOS] = discoveryItems.filter((item) => item.key === 'itemsEmergencyServ')
      const [basics] = discoveryItems.filter((item) => item.key === 'itemsBasics')
      const [vodafoneTv] = discoveryItems.filter((item) => item?.componentId === 'VodafoneTV')
      const [suport] = discoveryItems.filter((item) => item.key === 'itemsAssistance')
      const products = { ...this.props.products }
      let account = this.props.account
      const tobiUrl = this.props.tobiURL
      const businessAccount = ReduxCache.getBusinessAccount()

      const businessName = businessAccount?.businessName




      let modifiedSubItem = [...account?.subTray?.subTrayItems]

      modifiedSubItem = modifiedSubItem?.filter(item => item?.key !== 'logout')
      let modifiedAccount = {
        ...account,
        subTray: {
          ...account?.subTray,
          subTrayItems: [...modifiedSubItem]
        }
      }
      if (isBusinessChooser() && ReduxCache.getUserType() !== 'guest') {
        if (modifiedAccount.subTray?.subTrayItems?.filter(item => item.componentId === 'account_switch').length === 0) {
          const accountSwitch = {
            componentId: "account_switch",
            key: "account_switch",
            itemTitle: "account_switch_tray_button",
            itemImage: 'icBusinessUser',
            itemSubTitle: 'account_switch_tray_subtitle',
            itemSubtitlePlaceholder: this.props.accountSubtitle,
            extraStyle: { tintColor: theme.colors.textColor }
          }
          modifiedAccount.subTray.subTrayItems = [...modifiedAccount.subTray.subTrayItems, accountSwitch]
        }
      }
      if (isAdminView()) {
        if (products?.subTray?.subTrayItems?.filter(item => item.componentId === 'business_manage').length === 0) {
          const transferBalance = {
            componentId: "business_manage",
            key: "business_manage",
            itemTitle: "subtray_business_section_title",
            itemImage: 'business_image',
            itemSubTitle: 'subtray_business_section_users',
            itemSubtitlePlaceholder: totalUsers || '-',
          }
          products.subTray.subTrayItems = [transferBalance, ...products.subTray.subTrayItems]
        }
      }
      let basicSubItem = basics?.subItems || []
      basicSubItem.map((item, index) => {
        if (item?.key === 'fixBill') {

          basicSubItem.splice(index, 1)
        }
      })

      let suportItem = suport?.subItems || []
      let shouldCallBack = false
      SOS?.subItems?.map((item) => {
        if (item?.key === 'call_me_back') {
          shouldCallBack = true
        }
      })

      suportItem?.map((item, index) => {
        if (item.key === "netPerformSpeedtest") {
          suportItem[index].extraInfo = {
            ...suportItem[index].extraInfo,
            type: "webview",
            text: "https://www.vodafone.al"
          }
        }
      })


      const transferBalance = {
        componentId: "tranfer_balance",
        key: "tranfer_balance",
        name: "tranfer_balance",
        extraInfo: {
          icon: "ic_recharge_other",
          subTitle: null,
          title: 'tranfer_balance',
          type: "native",
          url: null
        }
      }

      const callMeBack = {
        componentId: "call_me_back",
        key: "call_me_back",
        name: "call_me_back",
        extraInfo: {
          icon: "ic_call_me_back",
          subTitle: null,
          title: 'call_me_back',
          type: "native",
          url: null
        }
      }


      const basicsAndSos = {
        type: 'group',
        subItems: SOS?.subItems ? [...basicSubItem, SOS?.subItems[0]] : [...basicSubItem],
        name: 'Shërbime bazë & SOS',
        moreText: '',
        lessText: ''
      }

      const assistance = {
        type: 'group',
        subItems: SOS?.subItems[1] ? [...suportItem, SOS?.subItems[1]] : shouldCallBack ? [...suportItem, callMeBack] : [...suportItem],
        name: ContentManager.translate('your_appointments_service_assistance'),
        moreText: '',
        lessText: ''
      }


      const DesiredComponent = _get(
        this.props.componentList,
        discover?.componentId,
        () => null
      )



      const { video, forceLandsacpe, poster, header, text } = vodafoneTv || {}

      const guestNotAllowedScreen = { 'payment': true, 'my_orders': true }

      const navigation = {
        'dashboardGuest': 'PreLogin',
        "myNumber": 'ProdutsAndServices',
        "GigaFamily": 'Gigaamily',
        "tidal": {
          isWebView: true,
          params: { "url": "https://offers.vodafone.com/al", "title": "Tidal", "isReact": true }
        },
        'payment': 'PaymentMethods',
        'settings': 'Settings',
        'tranfer_balance': 'DataSharing',
        'TOBi': {
          isWebView: true,
          params: { "url": tobiUrl, "isReact": true }
        },
        'my_contracts': 'FixContracts',
        'my_orders': 'ManageOrders',
        'maunal_line': 'FixBundles',
        'GigaFibra': 'FixProductsAndServices',
        'vodafoneTV': 'FixProductsAndServices',
        'business_manage': 'BusinessOverview',
        'myUsersAndGroup': 'UsersAndGroup'
      }
      const handleNaviagtion = (key, extraInfo) => {
        const userType = ReduxCache.getUserType()
        if (key === 'account_switch') {
          this.props.toggleAccountSwitch()
          return
        }
        if (guestNotAllowedScreen[key] && userType === 'guest') {
          this.props.navigate('TransparentPopup')
        } else {
          if (extraInfo?.type === "webview") {
            this.props.navigate('WebView', {
              url: extraInfo?.itemUrl,
              title: extraInfo?.itemTitle
            })
          } else {
            if (navigation[key]?.isWebView) {
              this.props.navigate('WebView', navigation[key]?.params)
            } else {
              this.props.navigate(navigation[key])
            }
          }
        }
      }

      const Item = ({ item, index, withRightIcon = false, extraStyle, isLast = false }) => {
        const {
          extraInfo,
          leftIconType,
          leftIconSize = 32,
          textStyle,
        } = item || {}



        return (
          <Pressable
            style={[{
              height: 84,
              borderRadius: 7,
              backgroundColor: theme.colors.cardBackgroundColor,
              flexDirection: 'row',
              padding: 25,
              alignItems: 'center', marginBottom: isLast ? 0 : 10, marginTop: index == 0 ? 0 : 10,
              shadowColor: colors.black,
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.16,
              shadowRadius: 8,
              elevation: 1,
            }, extraStyle]}
            onPress={() => { this.props.onPressDiscoverListItem(item) }}
            className='hoverBig'
          >

            <Icon
              type={leftIconType}
              name={this.props.images[extraInfo?.icon]}
              size={leftIconSize}
              style={{ tintColor: theme.colors.textColor }}
            />
            <VFText
              i18nKey={extraInfo?.title}
              style={[textStyle, { marginLeft: 16, fontSize: 20, fontWeight: 700, color: theme.colors.textColor }]}
            />
            {withRightIcon && <View style={{ flex: 1 }}>
              <Icon
                type='image'
                size={32}
                style={{ alignSelf: 'flex-end', flexDirection: 'row', tintColor: theme.colors.textColor }}
                name={this.props.images['ic_chevron_right_red']}
              />
            </View>}
          </Pressable>
        )
      }

      const SHIMMERDUMMY = [{}, {}, {}, {}]
      const calculateWidth = () => {
        let marginedSpace = 40 + ((basicsAndSos.subItems.length - 1) * 20)
        const width = (Dimensions.get('window').width - marginedSpace) / basicsAndSos.subItems.length
        if (width > 350) {
          return '350px'
        }
        return `${width}px`
      }

      const calculateHeight = () => {
        if (assistance?.subItems?.length < 2) {
          return 320
        }
        return (84 * assistance?.subItems?.length) + ((assistance?.subItems?.length - 1) * 20)
      }
      const calculateMyAccountWidth = () => {
        let marginedSpace = (modifiedAccount?.subTray?.subTrayItems?.length - 1) * 20
        const width = (Dimensions.get('window').width - marginedSpace - 40 - 8) / modifiedAccount?.subTray?.subTrayItems?.length
        return `${width}px`
      }


      return (
        <View style={{ width: '100%', backgroundColor: theme.colors.backgroundColor, paddingHorizontal: 3 }}>
          <View >
            {isLoadingDiscover ?
              <Shimmer config={[{ main: { type: 'line', count: 1, dimension: '100%', style: { height: 22, marginBottom: 16 } } }]} />
              : < VFText
                i18nKey={products?.title}
                style={{ fontSize: 28, fontWeight: 700, marginBottom: 32 }}
              />}

            <View style={{ flexDirection: 'row', flex: 1, marginBottom: 91 }}>
              {isLoadingDiscover ?
                SHIMMERDUMMY.map((item, index) => (
                  <View style={{
                    height: 156,
                    maxWidth: 156,
                    borderRadius: 7,
                    backgroundColor: theme.colors.cardBackgroundColor,
                    padding: 25, alignItems: 'center',
                    marginTop: 10, marginHorizontal: 8, shadowColor: colors.black,
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.16,
                    shadowRadius: 8,
                    elevation: 1,
                  }}>
                    <Shimmer config={[{ main: { type: 'circle', count: 1, style: { width: 100, minHeight: 22, margin: 'auto' } } }]} />
                    <Shimmer config={[{ main: { type: 'circle', count: 1, style: { height: 42, width: 100, margin: 'auto', marginVertical: 20 } } }]} />
                  </View>
                ))
                :
                products?.subTray?.subTrayItems?.map((item, index) => {
                  return (
                    <Pressable
                      onPress={() => { handleNaviagtion(item?.key, item) }}
                      key={index}
                      style={{
                        backgroundColor: theme.colors.cardBackgroundColor,
                        borderRadius: 6,
                        width: 156,
                        height: 156,
                        padding: 16,
                        marginLeft: index === 0 ? 0 : 12,
                        marginRight: 12,
                        alignItems: 'center',
                        shadowColor: colors.black,
                        shadowOffset: { width: 0, height: 2 },
                        shadowOpacity: 0.16,
                        shadowRadius: 8,
                        elevation: 1,
                      }}
                    >
                      <VFText
                        i18nKey={item?.itemTitle}
                        style={{ fontSize: 20, fontWeight: 700 }}
                      />
                      <VFText
                        i18nKey={item?.itemSubTitle}
                        style={{ fontSize: 16, fontWeight: 400 }}
                        placeHolders={[item?.itemSubtitlePlaceholder]}
                      />
                      <Icon
                        type='image'
                        size={100}
                        name={this.props.images[item?.itemImage]}
                        style={{ marginTop: 30 }}
                      />
                    </Pressable>
                  )
                })}
              <View style={{ flex: 1 }}>
                {/* <div style={{ backgroundColor: 'red' }}>
                          <Pressable onPress={() => { handleNaviagtion('TOBi') }} style={{ width: 100, height: 100, borderRadius: '50%', backgroundColor: 'white', alignSelf: 'flex-end', marginTop: 30, marginRight: 20, alignItems: 'center', }}>
                            <Image
                              source={Images.toBi}
                              style={{ width: 100, height: 100, alignSelf: 'center' }}
                              accessibilityLabel={'trayTobiIcon'}
                              testID={'trayTobiIcon'}
                            />
                          </Pressable>
                        </div> */}
              </View>
            </View>
          </View>

          <View
            nativeID='basicContainerId'
            style={{ flexDirection: 'row', flex: 1, minHeight: !offerAndRewards ? 450 : null, marginBottom: offerAndRewards?.subItems?.length > 3 ? 64 : null, minHeight: 'auto' }}>
            {
              offerAndRewards &&
              <View style={{ flex: 0.3, marginRight: 20, minWidth: 300 }}>
                <VFText i18nKey={offerAndRewards?.name} style={{ fontSize: 28, fontWeight: 700, marginBottom: 32 }} />
                <div style={{ display: 'flex', flexDirection: 'column' }} id='tilesContainer'>
                  {offerAndRewards?.subItems?.map((item, index) => (
                    <Item item={item} index={index} withRightIcon={true} isLast={index === offerAndRewards?.subItems?.length - 1} />
                  ))}
                </div>
              </View>
            }
            <View style={{ flex: 1 }}>
              <DesiredComponent
                leftSideLength={offerAndRewards?.subItems?.length}
                {...discover} />
            </View>


            {/* <View style={{ flex: 1 }}> */}
            {/* {
                discover ?
                  <VFText i18nKey={'dashboard_discovery_label'} style={{ fontSize: 28, fontWeight: 700, marginBottom: 32 }} />
                  : <Shimmer config={[{ main: { count: 1, dimension: '100%', type: 'line', style: { height: 32, marginBottom: 32 } } }]} />
              } */}
            {/* <DiscoverCard
                type={discover?.type}
                componentName={discover?.componentId}
                onPressCard={this.props.onPressCard}
                loadingConfig={discover?.discoverCardLoadingConfig}
                shimmerPlaceholderConfig={discover?.shimmerPlaceholderConfig}
                isLoading={discover?.isLoadingDiscover}
                style={discover?.discoverCardsStyle}
                discoverLoadingError={discover?.discoverLoadingError}
              >
              </DiscoverCard> */}
            {/* </View> */}
          </View>

          {basics ?
            <View style={{ marginTop: offerAndRewards?.subItems?.length - 3 > 0 ? `${(offerAndRewards?.subItems?.length - 3) * 64}px` : '64px' }}>
              <VFText
                i18nKey='dashboard_basic_group_and_sos_component_name'
                style={{ fontSize: 28, fontWeight: 700, marginBottom: 32 }}
              />
              <View style={{ flexDirection: 'row', flexWrap: 'wrap' }} >
                {basicsAndSos?.subItems?.map((item, index) => (
                  <Item item={item} extraStyle={{ width: Dimensions.get('window').width < 1550 ? calculateWidth() : 350, fontWeight: 500, marginRight: index === basicsAndSos.subItems.length - 1 ? 0 : 20, marginTop: 0 }} />
                ))}
              </View>
            </View>
            :
            basics && (
              <View style={{ marginTop: 64 }}>
                <Shimmer config={[{ main: { type: 'line', count: 1, style: { width: 100, height: 16, marginBottom: 32 } } }]} />
              </View>
            )
          }

          <View style={{ marginTop: 64, flexDirection: 'row', flex: 1 }}>
            <View style={{
              flex: 1
            }}>
              <VFText i18nKey={vodafoneTv?.name} style={{ fontSize: 28, fontWeight: 700, marginBottom: 32 }} />
              <View style={styles.containerStyle(theme)}>
                <View style={[styles.videoTextContainer, { maxHeight: `${calculateHeight()}px` }, assistance?.subItems?.length < 2 && { minHeight: `${calculateHeight()}px` }]}>
                  <ReactPlayer
                    className='react-player'
                    width={'100%'}
                    height={'100%'}
                    url={video}
                    playbackRate={1}
                    playing={this.state.playing}
                    controls={true}
                    loop={false}
                    light={poster}
                    onPlay={this.handlePlay}
                    onPause={this.handlePause}
                  />
                </View>

                <View style={styles.textContainer}>
                  <VFText
                    style={styles.header(theme)}
                    i18nKey={header}
                  />
                  <VFText style={styles.text(theme)} i18nKey={text} />
                </View>
              </View>
            </View>

            <View style={{ flex: 0.3, marginLeft: 20 }} onLayout={(e) => { this.setState({ ...this.state, heightOfPlayer: e.nativeEvent.layout.height }) }}>
              <VFText i18nKey={assistance?.name} style={{ fontSize: 28, fontWeight: 700, marginBottom: 32 }} />
              {assistance?.subItems?.map((item, index) => {
                return (
                  <Item item={item} index={index} withRightIcon={true} isLast={index == assistance?.subItems?.length - 1} />
                )
              })}
            </View>

          </View>

          <View style={{ marginTop: 64 }}>
            <VFText
              i18nKey={modifiedAccount?.title}
              style={{ fontSize: 28, fontWeight: 700, marginBottom: 32 }}
            />
            <ScrollView horizontal style={{ display: 'flex', flexDirection: 'row', padding: 4 }} >
              {modifiedAccount?.subTray?.subTrayItems?.map((item, index) => {
                return (
                  <Pressable
                    onPress={() => { handleNaviagtion(item?.key, item) }}
                    key={index}
                    style={{
                      backgroundColor: theme.colors.cardBackgroundColor,
                      borderRadius: 6,
                      minWidth: calculateMyAccountWidth(),
                      height: 156,
                      padding: 16,
                      marginLeft: index === 0 ? 0 : 10,
                      marginRight: 10,
                      alignItems: 'center',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      shadowColor: colors.black,
                      shadowOffset: { width: 0, height: 2 },
                      shadowOpacity: 0.16,
                      shadowRadius: 8,
                      elevation: 1,
                    }}
                  >
                    <View>
                      <VFText
                        i18nKey={item?.itemTitle || ''}
                        style={{ fontSize: 20, fontWeight: 700 }}
                      />
                      <VFText
                        i18nKey={item?.itemSubTitle || ''}
                        style={{ fontSize: 16, fontWeight: 400, marginTop: 12 }}
                        placeHolders={[item?.itemSubtitlePlaceholder]}
                      />
                    </View>
                    <Icon
                      type='image'
                      size={100}
                      name={this.props.images[item?.itemImage]}
                      style={item?.extraStyle}
                    />
                  </Pressable>
                )
              })}
            </ScrollView>
          </View>

        </View>
      )
    }
    else {
      return (<Animated.FlatList
        scrollEventThrottle={16}
        contentContainerStyle={styles.flatListStyle}
        showsHorizontalScrollIndicator={false}
        data={discoveryItems}
        renderItem={this.renderEachDiscover}
        keyExtractor={(item, index) => `${item.name}-${index}`}
        testID={FrameworkTestKeys.dashboardContainerAnimatedFlatlist}
      />)
    }
  };

  handleConnectedAppsRefresh = onRefreshApps => {
    this.onRefreshApps = onRefreshApps;
  };

  handleRefreshDashboard = async () => {
    const { onRefresh } = this.props;
    _.isFunction(this.onRefreshApps) && this.onRefreshApps();
    const isRefreshed = await onRefresh();
    return isRefreshed;
  };

  renderDiscoverFullError = () => {
    const { discoverFullErrorProps } = this.props;

    return (
      <ErrorScreen
        backgroundStyle={styles.errorBackgroundStyle}
        iconStyle={styles.errorIconStyle}
        textStyle={styles.errorTextStyle}
        {...discoverFullErrorProps}
      />
    );
  };

  renderEachDiscover = ({ item, index }) => {
    const { isLoadingDiscover } = handleIsLoading(this.props.isLoading);

    if (item.type === 'group') {
      return (
        <GroupCard
          ref={comp => {
            this.cardsRefs[index] = comp;
          }}
          header={item.name}
          moreText={item.moreText}
          lessText={item.lessText}
          items={item.subItems}
          onPressDiscoverListItem={this.props.onPressDiscoverListItem}
          images={this.props.images}
          viewAccessibilityLabel={`${item.name}${FrameworkTestKeys.DashboardContainerView}`}
          listTitleAccessibilityLabel={
            item.titleAccessibilityLabel ||
            `${item.name}${FrameworkTestKeys.DashboardContainerTitle}`
          }
          itemsAccessibilityLabel={
            item.listAccessibilityLabel ||
            `${item.name}${FrameworkTestKeys.DashboardContainerSection}`
          }
          itemName={item.name}
          headerStyle={this.props.groupHeaderStyle}
        />
      );
    } else if (item.type === 'apps') {
      return (
        <ConnectedApps
          onRefreshConnectedApps={this.handleConnectedAppsRefresh}
          items={item.subItems}
          title={item.name}
          moreText={item.moreText}
          lessText={item.lessText}
          ref={comp => {
            this.cardsRefs[index] = comp;
          }}
          onPressDiscoverListItem={this.props.onPressDiscoverListItem}
          images={this.props.images}
          viewAccessibilityLabel={FrameworkTestKeys.DBotherAppsView}
          listTitleAccessibilityLabel={FrameworkTestKeys.DBotherAppsTitle}
          itemsAccessibilityLabel={FrameworkTestKeys.DBotherAppsSection}
          itemName="DBotherApps"
        />
      );
    }

    // get the type out of the item so it doesn't override the card type
    const { type, id, ...props } = item;
    const DesiredComponent = _.get(this.props.componentList, item.componentId, () => null);

    return (
      <DiscoverCard
        ref={comp => {
          this.cardsRefs[index] = comp;
        }}
        type={type}
        componentName={item.componentId}
        onPressCard={this.props.onPressCard}
        loadingConfig={this.props.discoverCardLoadingConfig}
        shimmerPlaceholderConfig={this.props.shimmerPlaceholderConfig}
        isLoading={isLoadingDiscover}
        style={this.props.discoverCardsStyle}
        discoverLoadingError={this.props.discoverLoadingError}
        {...props}
      >
        <DesiredComponent {...props} />
      </DiscoverCard>
    );
  };

  renderItem = data => {
    const { ...props } = data;
    if (data?.componentName === 'DashboardDiscovery') {
      return (
        <DashboardDiscover
          setDiscoverRef={this.props.setDiscoverRef}
          isCurrentScreen={this.props.isCurrentScreen}
          title={data.title}
          dashboardDiscover={this.getDashboardDiscover(data)}
          cardsRefs={this.cardsRefs}
          isBackground={this.props.isBackground}
          headerTitleStyle={this.props.discoverHeaderStyle}
          {...props}
        />
      );
    }
    return null;
  };

  render() {
    const {
      spaceType,
      onRefresh,
      data,
      refreshInterval,
      images,
      lastUpdateTime,
      setLastUpdateTime,
      lastUpdatedLoadingConfig,
      shimmerPlaceholderConfig,
      isLoading,
      hasShadow,
      dashboardTopOffset,
      dashboardMainCardsContainerStyle,
      refreshTitleStatusKeys,
    } = this.props;
    const { isLoadingDashboard, isLoadingDiscover } = handleIsLoading(isLoading);

    return (
      <Dashboard
        setDiscoverRef={this.props.setDiscoverRef}
        mainCards={this.getMainCards()}
        hasShadow={true}
        discover={this.renderItem(isLoadingDiscover ? LoadingJson.discovery : data[1])}
        onRefresh={_.isFunction(onRefresh) ? this.handleRefreshDashboard : undefined}
        lastUpdatedLoadingConfig={lastUpdatedLoadingConfig}
        shimmerPlaceholderConfig={shimmerPlaceholderConfig}
        refreshInterval={refreshInterval}
        images={images}
        lastUpdateTime={lastUpdateTime}
        setLastUpdateTime={setLastUpdateTime}
        cardsLoading={isLoadingDashboard}
        spaceType={spaceType}
        dashboardTopOffset={dashboardTopOffset}
        dashboardMainCardsContainerStyle={dashboardMainCardsContainerStyle}
        refreshTitleStatusKeys={refreshTitleStatusKeys}
      />
    );
  }
}

DashboardContainer.defaultProps = {
  dashboardLoadingConfig: _dashboardLoadingConfig,
  discoverCardLoadingConfig: _discoverCardLoadingConfig,
  lastUpdatedLoadingConfig: _lastUpdatedLoadingConfig,
  shimmerPlaceholderConfig: _shimmerPlaceholderConfig,
};

DashboardContainer.propTypes = {
  setDiscoverRef: PropTypes.func,
  isLoading: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      discover: PropTypes.bool,
      dashboard: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.shape({
          isLoadingMainCard: PropTypes.bool,
          isLoadingSecondaryCard: PropTypes.bool,
          isLoadingThirdCard: PropTypes.bool,
          isLoadingFourthCard: PropTypes.bool,
        }),
      ]),
    }),
  ]),
  shimmerPlaceholderConfig: PropTypes.object,
  lastUpdatedLoadingConfig: PropTypes.array,
  setLastUpdateTime: PropTypes.func,
  lastUpdateTime: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.number,
    PropTypes.string,
  ]),
  images: PropTypes.object,
  discoverFullErrorProps: PropTypes.object,
  refreshInterval: PropTypes.func,
  onRefresh: PropTypes.func,
  isCurrentScreen: PropTypes.bool,
  isBackground: PropTypes.bool,
  hasShadow: PropTypes.bool,
  onPressCard: PropTypes.func,
  componentList: PropTypes.object,
  onPressDiscoverListItem: PropTypes.func,
  dashboardLoadingConfig: PropTypes.object,
  discoverCardLoadingConfig: PropTypes.array,
  data: PropTypes.array,
  spaceType: PropTypes.number,
  discoverCardsStyle: ViewPropTypes.style,
  discoverHeaderStyle: TextPropTypes.style,
  groupHeaderStyle: TextPropTypes.style,
  discoverLoadingError: PropTypes.object,
  dashboardTopOffset: PropTypes.number,
  dashboardMainCardsContainerStyle: ViewPropTypes.style,
  refreshTitleStatusKeys: PropTypes.shape({
    updatedNow: PropTypes.string,
    sinceLastUpdate: PropTypes.string,
  }),
};

export default DashboardContainer;
